// Segmento de rota de cada tipo de mapa, igual para /easyMaps/mapa/ e
// /easyMaps/mapa/public/: 0 geo, 3 ftth (onus), 4 ping; topologia e pop vão para top.
const mapRouteSegment = (tipo) =>
  tipo === 0 ? "geo" : tipo === 3 ? "onus" : tipo === 4 ? "ping" : "top";

export default mapRouteSegment;
